import React from 'react';

export type TariffName = (typeof TariffName)[keyof typeof TariffName];
export const TariffName = {
    Launch: 'Launch',
    Growth: 'Growth',
    Wealth: 'Wealth',
} as const;

export type TariffFlag = (typeof TariffFlag)[keyof typeof TariffFlag];
export const TariffFlag = {
    ComingSoon: 'ComingSoon',
    Exclusive: 'Exclusive',
} as const;

export type TariffDescriptionProps = {
    textContent: null | React.JSX.Element;
    featureList: null | string[];
};

export type TariffAttributes = {
    title: TariffName;
    subtitle: string;
    shortDescription: string;
    flags: TariffFlag[];
};
